/**
 * PostHog 초기화 (optional — VITE_POSTHOG_KEY 없으면 no-op)
 * SSOT: synaxion-core/09-observability/
 */

import posthog, { type PostHogInterface } from 'posthog-js';

let initialized = false;

export function initPostHog(): void {
  const key = import.meta.env.VITE_POSTHOG_KEY?.trim();
  if (!key || initialized) return;

  posthog.init(key, {
    api_host: import.meta.env.VITE_POSTHOG_HOST?.trim() || 'https://app.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: false,
    persistence: 'localStorage+cookie',
    loaded: (ph: PostHogInterface) => {
      if (import.meta.env.DEV) ph.opt_out_capturing();
    },
  });

  initialized = true;
}

export function capturePageView(path: string): void {
  if (!initialized) return;
  posthog.capture('$pageview', { $current_url: path });
}

export function captureEvent(event: string, properties?: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export function identifyUser(userId: string, traits?: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.identify(userId, traits);
}

export function resetUser(): void {
  if (!initialized) return;
  posthog.reset();
}

export function isPostHogEnabled(): boolean {
  return initialized;
}
